<template>
<section>

    <div class="wrap">
        <p class="matching_count">맞춤 매칭된 컨설턴트의 정보를 확인해 보세요 <span>{{swiperIndexView}}/{{scItems.length}}</span></p>
    </div>
    
    <swiper
        ref="scSwiper"
        class="swiper recommend_slide"
        style="padding:0 10px"
        :options="swiperOption"
        @slideChangeTransitionStart="onSwiperSlideChangeTransitionStart"
    >
        <swiper-slide class="item"               
            v-for="sc in scItems" 
            :key="`sc-recommend-result-item-${sc.id}`"
        >
            <div class="carousel-shadow">
                <div class="consultant_img">
                    <span v-if="sc.certificationYn == 'Y'">
                        <img :src="resource.imgIconCertified">인증
                    </span>
                    <img :src="sc.attUrl ? sc.attUrl : resource.imgSampleConsultantSquare" style="position:absolute;top:0; left:0">
                    <dl>
                        <dt>{{sc.name}} 컨설턴트</dt>
                        <dd>경력 {{ $_getScCareerByMonth(sc.careerMonth) }}ㆍ{{sc.shopName}}ㆍ{{sc.dealerName}}
                            <span><i class="fas fa-star"></i>{{reviewRatingAvg(sc.reviewSum, sc.reviewTotal)}}({{sc.total}}명)</span>
                        </dd>
                    </dl>
                </div>

                <div class="consultant_info">
                    <div class="consultant_info_contants">
                        <!--
                        <dl>
                            <dt>
                                {{sc.name}} 컨설턴트
                                <span><img :src="resource.imgIconGood">{{ sc.good }}</span>
                            </dt>
                            <dd>
                                <span>{{sc.shopName}}</span>
                                <span>{{sc.dealerName}}</span>
                            </dd>
                        </dl>
                        -->
                        <div class="consultant_info_sub">
                            <ul>
                                <li>
                                    전시장 위치 : 현재 위치로 부터 {{$_toFixed(sc.distance) }}km
                                </li>
                                <li>
                                    최근 30일 예약 건수 : <span>{{ sc.consultingCount }}건</span>
                                </li>
                                <li class="reviewHide">
                                    최근 상담차량 : <span>{{ sc.lastTrimName ? sc.lastTrimName : "없음" }}</span>
                                </li>
                            </ul>
                        </div> 
                    </div>
                    <a @click="next(sc)">예약 하기</a>
                </div>
            </div>
        </swiper-slide>
    </swiper>

    <div class="consultant_find_btn">
        <router-link :to="routerScPath">컨설턴트 직접 찾아보기</router-link>
    </div>

</section>
</template>

<script>
import { mapState } from 'vuex';
import { NumberFormatMixin } from '../../mixins/NumberFormatMixin';
export default {
    name:'ScRecommentResult',
    mixins: [NumberFormatMixin],
    async created() {
        this.$store.state.headerTitle = '추천 매칭 결과';
        await this.$store.dispatch('GET_SC_LIST_RECOMMEND',
            {
                trimId: this.bookingWrite.trimId,
                lat: this.bookingWrite.lat,
                har: this.bookingWrite.har,
                type: this.bookingWrite.type,
                choice: this.bookingWrite.choice.toString(),
                bookingDt: this.bookingWrite.bookingDt
            }
        );
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1.2, //화면에 slide 노출 개수
            },

            swiperIndex:0,
        }
    },
    computed: {
        ...mapState({
            scItems : state => state.sc.items,

            bookingWrite: state => state.booking.itemWrite,
            resource: state => state.resource,
        }),

        bookingId(){
            return Number(this.$route.params.bookingId);
        },

        routerPath() {
            let path = '/booking/inputVehicle';
            return (this.bookingId) ? `${path}/${this.bookingId}`: path;
        },

        routerScPath(){
            let path = '/scList';
            return (this.bookingId) ? `${path}/${this.bookingId}`: path;
        },

        scSwiperIndex() {
            return (this.$refs.scSwiper) ? this.$refs.scSwiper.$swiper.realIndex : 0;
        },
        swiperIndexView() {
            return (this.scItems.length == 0) ? 0 : this.swiperIndex + 1; 
        },
    },
    methods: {
        next(sc) {
            this.bookingWrite.scId = sc.id;
            this.bookingWrite.scName = sc.name;
            this.bookingWrite.scUrl = sc.attUrl;
            this.bookingWrite.scShopName = sc.shopName;
            this.bookingWrite.scDealerName = sc.dealerName;
            this.$router.push(this.routerPath);
        },

        onSwiperSlideChangeTransitionStart(){
            this.swiperIndex = this.$refs.scSwiper.$swiper.realIndex;
        },
    },
}
</script>

<style scoped>
</style>